import _toUpper from "ramda/src/toUpper";
import _is from "ramda/src/is";
import _when from "ramda/src/when";
import _typeof from "@babel/runtime/helpers/typeof";
import _replace from "ramda/src/replace";
import _toLower from "ramda/src/toLower";
import _pipe from "ramda/src/pipe";
import _curry from "ramda/src/curry";
export var template = _curry(function (tmpl, variables) {
  return tmpl.replace(/\${([\sA-Z0-9_$]+)}/gi, function (match, variable) {
    return variables[variable.trim()] || '';
  });
});
export var slugify = _pipe(_toLower, _replace(/[^a-z0-9]/g, '-'), _replace(/-+/g, '-'), _replace(/^-|-$/g, ''));
export var escapeRegExpStr = _replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
export var fromBase64 = function fromBase64(str) {
  if (typeof Buffer === 'function') return Buffer.from(str, 'base64').toString();
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof atob === 'function') return atob(str);
  throw Error('Missing fromBase64 implementation');
};
export var toBase64 = function toBase64(str) {
  if (typeof Buffer === 'function') return Buffer.from(str).toString('base64');
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && typeof btoa === 'function') return btoa(str);
  throw Error('Missing toBase64 implementation');
};
export var capitalize = _when(_is(String), _replace(/^./, _toUpper));